import { useMemo } from 'react';

import { useGetUsersSummaryByIds } from '~/hooks/apis/users/useGetUsersSummaryByIds';

import { Voucher } from '~/services/PromoService';

type Params = {
  vouchers: Array<Voucher>;
  brand: string;
};

/** Resolves voucher creators and modifiers with the shared, batched user-summary lookup. */
export function useVoucherAuditUsers({ vouchers, brand }: Params) {
  const userIds = useMemo(() => {
    const ids = vouchers.flatMap((voucher) => [voucher.createdBy, voucher.updatedBy]).filter(Boolean);
    return Array.from(new Set(ids)).sort();
  }, [vouchers]);

  return useGetUsersSummaryByIds({
    userIds,
    brand,
    enabled: userIds.length > 0,
  });
}
